import React from 'react';
import PropTypes from 'prop-types';
import CtaButton from 'apps/ddo/components/CtaButton';
import TrackClick from './TrackClick';

export default class MainCtaButton extends React.Component {
    ctaButton(messageKey, url, variation, isDisabled) {
        const button =
            messageKey === 'main_cta_see_profile' ? (
                <TrackClick element="main_cta_see_profile">
                    <CtaButton
                        variation={variation}
                        url={url}
                        messageKey={messageKey}
                        isDisabled={isDisabled}
                    />
                </TrackClick>
            ) : (
                <CtaButton
                    variation={variation}
                    url={url}
                    messageKey={messageKey}
                    isDisabled={isDisabled}
                />
            );
        return button;
    }

    render() {
        if (!this.props.design.permission.userIdentified) {
            return this.ctaButton(
                'main_cta_see_profile',
                this.props.design.links.profileUrl,
                'primary',
                false
            );
        } else if (this.props.design.permission.canEdit) {
            return this.ctaButton(
                'main_cta_edit',
                this.props.design.links.editDesignUrl,
                'secondary',
                false
            );
        } else if (this.props.design.permission.designerUnavailable) {
            return this.ctaButton('main_cta_unavailable', null, 'primary', true);
        } else if (this.props.design.permission.canInvite) {
            return this.ctaButton(
                'main_cta_invite',
                this.props.design.links.inviteToWorkUrl,
                'primary',
                false
            );
        }
        return null;
    }
}

MainCtaButton.contextTypes = {
    intl: PropTypes.object.isRequired,
};

MainCtaButton.propTypes = {
    design: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};



// WEBPACK FOOTER //
// ./src/js/apps/ddo/components/MainCtaButton.jsx